export const getArticleCollectPageUrl = (articleSlug: string) => `/article/${articleSlug}/collect`;
